import styles from "./product-image.module.css";


export interface ProductImageProps {
  imageUrl: string;
  alt?: string;
  size?: string;
  className?: string;
}

export default function ProductImage(props: ProductImageProps) {
  const {
    imageUrl,
    alt = "product",
    size = "4rem",
    className,
    ...rest
  } = props;

  return (
    <div className={styles.container + ` ${className ? className : ""}`}>
      <img className={styles.styledImage} src={imageUrl} alt={alt} style={{height:size,aspectRatio:1}} />
    </div>
  );
}
